const io = require("socket.io-client")(process.env.VUE_APP_API_URL);
import { Vue, Component } from 'vue-property-decorator';

@Component
export default class Socket extends Vue {
    created() { 
        this.$store.commit("initSocket", io);
        console.log("Socket init"); 
    }
    mounted() {
        this.socket.on("update_chat_status", (status:any) => {
            if(!this.$store.state.isDashboard) {
                setTimeout(() => {
                    this.setChatDelay(status);
                }, this.latency)
            } else {
                this.$store.commit("updateEvent", { name: "chatStatus", value: status });
            }
        });
        this.socket.on("new_comment", (comment:any) => {
            this.$store.commit("pushComment", comment);
        });
        this.socket.on("comment_deleted", (commentId:string) => {
            this.$store.commit("deleteComment", commentId);
        })
        this.socket.on("viewer_count", (count:number) => {
            this.$store.commit("viewerCount", count);
        })
        this.socket.on("users_with_votes", (count:number) => {
            this.$store.commit("usersWithVotesCount", count);
        })
        this.socket.on("current_votes", (count:number) => {
            this.$store.commit("voteCount", count); 
            if(count === 0) this.$store.commit("cutVotesCount", 0);
        })
        this.socket.on("companies_online", (count: any) => {
            this.$store.commit("companyCount", count);
        })
        this.socket.on("vote_processed", (result:any) => {
            this.$store.commit("processVote", result);
        })
        this.socket.on("cut_votes", (count:number) => {
            this.$store.commit("cutVotesCount", count);
        })

        this.socket.on("cut_users", (users:any) => {
            this.$store.commit("setCutUsers", users)
        })

        this.socket.on("online_users", (users:Array<String>) => {
            this.$store.commit("userCount", users.length);
            if(this.user._id) {
                const isOnline = users.filter((id) => id === this.user._id);
                if(isOnline.length > 1) { 
                    localStorage.removeItem("access_token");
                    location.reload();
                }
            }
        })

        this.socket.on("new_poll", (poll:any) => {
            this.$store.commit('newPoll', poll)
        })

        this.socket.on("poll_status_changed", (poll:any) => {
            if(!this.$store.state.isDashboard) {
                if(this.user.voteCount || this.user.mandates.length) {
                    setTimeout(() => {
                        this.$store.commit("updatePoll", poll);
                    }, this.latency)
                }
            } else {
                this.$store.commit("updatePoll", poll);
            }
        });

        this.socket.on("poll_deleted", (id:string) => {
            this.$store.commit("deletePoll", id);
        })

        this.socket.on("disconnect", ()=>{
            console.log('Socket disconnected')
        })
        this.socket.on("reconnect", () => {
            if(this.event._id) this.socket.emit("join_event", this.event._id);
            if(this.user._id) this.socket.emit("register_user", this.user._id);
        })
        this.socket.on("connect_error", ()=>{
            console.log('Socket connect error')
        })
        
    }
    setChatDelay(status:any) {
        if(status.delay) { 
            let delay = status.delay;
            this.$store.commit("updateChatCounter", delay);

            setTimeout(() => {
                this.$store.commit("updateEvent", { name: "chatStatus", value: status });
            }, delay * 1000);

            let chatCounter = setInterval(() => {
                const count = this.$store.state.chatCounter;
                if(count <= 0) clearInterval(chatCounter);
                else this.$store.commit("updateChatCounter", count - 1);
            }, 1000)
        } else {
            this.$store.commit("updateEvent", { name: "chatStatus", value: status });
        }
    }
    get event() {
        return this.$store.state.event;
    }
    get user() {
        return this.$store.state.user;
    }
    get socket() {
        return this.$store.state.socket;
    }
    get latency() {
        return this.$store.state.streamLatency * 1000;
    }
    get isChatEnabled() {
        if(!this.event.chatStatus) return false;

        const status = this.event.chatStatus.status;
        if(status === 'open') return false;
        return true;
    }
}